<template>
  <div class="dashboard-overview">
    <div class="page-title">
      {{ $t('dashboard.overview') }}
    </div>

    <BalancePanel />
    <TotalTransactionDataPannelAgent @changeShowType="changeShowType" />
    <div class="transaction-trends-container">

      <div class="bar-container">
        <div class="text-title">
          {{ $t('dashboard.transaction_trends') }}
          <el-tooltip placement="bottom">
            <div slot="content">
              <span>{{ $t('tips.current_time_zone') }}</span>
            </div>
            <span><svg-icon icon-class="icon-font-warning" style="width: 22px;color: #0058CF;cursor: pointer;" /></span>
          </el-tooltip>
        </div>
        <bar-chart v-loading="loading" :char-data="charData" />
      </div>
      <div class="data-container">
        <div class="text-title">
          {{ $t('components.filter') }}
        </div>
        <div class="filter-item" style="margin-bottom: 12px;margin-top: 24px;">
          <span class="filter-label">{{ $t('components.date') }}</span>
          <el-select v-model="activeColor" class="search-frame mb-10" clearable @change="onClickchangeTimes">
            <el-option
              v-for="(item,index) in dateArr"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div style="margin-bottom: 24px;" class="filter-item">
          <span class="filter-label">{{ $t('components.view') }}</span>
          <el-select v-model="showType" class="search-frame" clearable>
            <el-option
              v-for="(item,index) in showTypeTransaction === 'second'? transaction_payin: transaction"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <el-button class="btn-search mb-10" type="primary" size="small" icon="el-icon-search" @click="getCharData">{{ $t('components.search') }}</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import { fetchDisbursementData, fetchPaymentData } from '@/api/dashboard/dashboard'
import BalancePanel from './BalancePanel'
import BarChart from './BarChart'
import TotalTransactionDataPannelAgent from './TotalTransactionDataPannelAgent'

export default {
  name: 'Dashboard-Overview',
  components: {
    BalancePanel,
    BarChart,
    TotalTransactionDataPannelAgent
  },
  data() {
    return {
      charData: {
        payAmountY: [],
        timesX: [],
        disAmountY: []
      },
      transaction: [
        { label: this.$t('dashboard.transaction_count'), value: 'number' },
        { label: this.$t('dashboard.transaction_amount'), value: 'amount' }],
      transaction_payin: [
        { label: this.$t('dashboard.transaction_count'), value: 'number' },
        { label: this.$t('dashboard.transaction_amount'), value: 'amount' },
        { label: this.$t('dashboard.refund_number'), value: 'refund_number' },
        { label: this.$t('dashboard.refund_amount'), value: 'refund_amount' }],
      activeColor: 'week',
      showType: 'number',
      showTypeTransaction: '',
      loading: false,
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  computed: {
    dateArr() {
      return [
        { label: this.$t('dashboard.week'), value: 'week' },
        { label: this.$t('dashboard.month'), value: 'month' }
      ]
    }
  },
  watch: {
    '$store.getters.language'() {
      this.getCharData()
    }
  },
  mounted() {
    const { token } = this.$store.getters
    if (token) {
      this.getCharData()
    }
  },
  methods: {
    disabledDate(time) {
      return time.getTime() > Date.now()
    },
    // 获取支付和代付数据
    getCharData() {
      const params = { range: (this.activeColor || 'day').toUpperCase() }
      if (this.loading) {
        return
      }
      this.loading = true
      Promise.all([fetchPaymentData(params), fetchDisbursementData(params)]).then((res) => {
        const [payData = {}, disData] = res
        const { code: payCode, data: charPayY } = payData
        const { code: disCode, data: charDisY } = disData
        // 获取支付金额y轴数据
        const totalAmouts = []
        const totalNumbers = []
        const toDivide100 = this.$options.filters['toDivide100']
        const payAmountY = charPayY.map(item => {
          const itemAmout = toDivide100(item.total_amount)
          totalAmouts.push(itemAmout)
          return itemAmout
        })
        // 获取支付笔数y轴数据
        const payNumberY = charPayY.map(item => {
          const itemNumber = item.daily_count
          totalNumbers.push(itemNumber)
          return itemNumber
        })
        // 获取代付金额y轴数据
        const disAmountY = charDisY.map((item, index) => {
          const itemAmout = toDivide100(item.total_amount)
          totalAmouts[index] = totalAmouts[index] + itemAmout
          return itemAmout
        })
        // 获取代付笔数y轴数据
        const disNumberY = charDisY.map((item, index) => {
          const itemNumber = item.daily_count
          totalNumbers[index] = totalNumbers[index] + itemNumber
          return itemNumber
        })
        // 获取x轴数据
        const timesX = charPayY.map(item => {
          if (item.create_date_str && item.create_date_str.includes('-')) {
            return item.create_date_str.split('-').slice(1).join('/')
          } else {
            return item.create_date_str
          }
        })

        if (this.showType === 'number') {
          this.charData = {
            payY: payNumberY,
            disY: disNumberY,
            // allY: totalNumbers,
            timesX,
            config: {
              yAxisName: this.$t('dashboard.number'),
              seriesName: [this.$t('dashboard.payin_number'), this.$t('dashboard.payout_number'), 'all number']
            }
          }
        }
        if (this.showType === 'amount') {
          this.charData = {
            payY: payAmountY,
            disY: disAmountY,
            // allY: totalAmouts,
            timesX,

            config: {
              yAxisName: this.$t('dashboard.amount'),
              seriesName: [this.$t('dashboard.payin_amount'), this.$t('dashboard.payout_amount'), 'all amount']
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onClickchangeTimes(dateStr) {
      if (!dateStr) {
        this.activeColor = 'week'
      }
    },
    onClickSearchBtn() {
      this.getCharData()
    },
    changeShowType(value) {
      this.showTypeTransaction = value
    }
  }
}
</script>

<style lang="scss" scoped>
.text-title{
  color: #364250;
  font-size: 24px;
  font-weight: 600;
}
.filter-label{
  margin-right: 10px;
  color: #364250;
  font-size: 16px;
  font-weight: 600;
}
.filter-item{
  display: flex;
  align-items: center;
}
.search-frame{
  flex: 1;
}
  .transaction-trends-container{
    display: flex;
    margin-top:24px;
    border-radius: 8px;
    padding: 24px;
    background: #FFFFFF;
  }
  .bar-container{
    flex: 1
  }
  .btn-search{
    width: 100%;
    font-size: 14px;
    padding: 12px;
  }
  .data-container{
    width: 25%;
  }
</style>
